import { capitalizeFirstLetter } from "@app/utils";
import { PaymentMethod } from "../models";

export const maskedPaymentMethod = (
  paymentMethod?: PaymentMethod | null
): string => {
  if (!paymentMethod || !paymentMethod.brand || !paymentMethod.last4digits) {
    return "-";
  }

  const brand = capitalizeFirstLetter(paymentMethod.brand);
  const last4 = paymentMethod.last4digits;

  return `${brand} •••• ${last4}`;
};
